export default "__VITE_ASSET__BMhi$0BY__"